import { Body, buttonLinkG4P, link } from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../intl";
import { useAppContext } from "../useAppContext";

type Props = {
  onClick?: () => unknown;
};

export function ForgotPasswordLink(props: Props) {
  const formatMessage = useFormatMessage();
  const {
    config: { settingsPageURL },
  } = useAppContext();
  return (
    <Body size="small" weight="regular">
      {[
        formatMessage("Login.forgotPasswordText"),
        props.onClick
          ? buttonLinkG4P(
              props.onClick,
              formatMessage("Login.forgotPasswordLink"),
              formatMessage("Login.forgotPasswordLink.linkPurpose")
            )
          : link(
              settingsPageURL,
              formatMessage("Login.forgotPasswordLink"),
              formatMessage("Login.forgotPasswordLink.linkPurpose")
            ),
      ]}
    </Body>
  );
}
